import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { TapFeedback } from '@/components/TapFeedback';
import { Home } from './pages/Home';
import { BackupPage } from './pages/bxy/BackupPage';
import { MigrationPage } from './pages/bxy/MigrationPage';
import { NotesPage } from './pages/bxy/NotesPage';
import { DataPage } from './pages/bxy/DataPage';
import { ShushuDataPage } from './pages/shushu/DataPage';
import { ShushuBackupPage } from './pages/shushu/BackupPage';
import { ShushuMigrationPage } from './pages/shushu/MigrationPage';
import { ShushuNotesPage } from './pages/shushu/NotesPage';
import { ShushuNoteDetailPage } from './pages/shushu/NoteDetailPage';
import { ShushuBatchActionPage } from './pages/shushu/BatchActionPage';
import { ShushuTaskDetailPage, ShushuTasksPage } from './pages/shushu/TasksPage';
import { ShushuXhsAccountCreatedPage } from './pages/shushu/xhs/AccountCreatedPage';
import { ShushuXhsCollectExportPage } from './pages/shushu/xhs/CollectExportPage';
import { ShushuXhsDownloadPage } from './pages/shushu/xhs/DownloadPage';
import { ShushuXhsInteractionsPage } from './pages/shushu/xhs/InteractionsPage';
import { ShushuCommentCleanerPage } from './pages/shushu/CommentCleanerPage';
import { ShushuCommentBackupPage } from './pages/shushu/CommentBackupPage';
import { ShushuExportPage } from './pages/shushu/ExportPage';
import { TasksPage } from './pages/bxy/TasksPage';
import { TaskDetailPage } from './pages/bxy/TaskDetailPage';
import { PageShell } from '@/components/PageShell';
import { Button } from '@/components/ui/button';

function NotFound() {
  return (
    <PageShell title="页面不存在" description="检查 URL；承载页路径约定见 README。" backTo="/">
      <Button asChild variant="outline" className="w-fit">
        <a href="/">返回首页</a>
      </Button>
    </PageShell>
  );
}

export function App() {
  return (
    <BrowserRouter>
      {/* 全局点按触感（原生按钮都有，WebView 里补上） */}
      <TapFeedback />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/bxy/backup" element={<BackupPage />} />
        <Route path="/bxy/migration" element={<MigrationPage />} />
        <Route path="/bxy/notes" element={<NotesPage />} />
        <Route path="/bxy/data" element={<DataPage />} />
        <Route path="/bxy/tasks" element={<TasksPage />} />
        <Route path="/bxy/tasks/:taskId" element={<TaskDetailPage />} />
        <Route path="/shushu/data" element={<ShushuDataPage />} />
        <Route path="/shushu/backup" element={<ShushuBackupPage />} />
        <Route path="/shushu/migration" element={<ShushuMigrationPage />} />
        <Route path="/shushu/notes" element={<ShushuNotesPage />} />
        <Route path="/shushu/notes/:id" element={<ShushuNoteDetailPage />} />
        <Route path="/shushu/batch" element={<ShushuBatchActionPage />} />
        <Route path="/shushu/tasks" element={<ShushuTasksPage />} />
        <Route path="/shushu/tasks/:taskId" element={<ShushuTaskDetailPage />} />
        <Route path="/shushu/xhs/download" element={<ShushuXhsDownloadPage />} />
        <Route path="/shushu/xhs/account-created" element={<ShushuXhsAccountCreatedPage />} />
        <Route path="/shushu/xhs/collect-export" element={<ShushuXhsCollectExportPage />} />
        <Route path="/shushu/xhs/interactions" element={<ShushuXhsInteractionsPage />} />
        <Route path="/shushu/comment-cleaner" element={<ShushuCommentCleanerPage />} />
        <Route path="/shushu/comment-backup" element={<ShushuCommentBackupPage />} />
        <Route path="/shushu/export" element={<ShushuExportPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
